import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ag-grid-enterprise-column-def',
	templateUrl:'./AgGridEnterpriseColumnDefPluginCompPage.html',
	styles: [],
	styleUrls:['./AgGridEnterpriseColumnDefPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AgGridEnterpriseColumnDefPluginCompPage
{
	mdContent_717 = `\`\`\`java
import com.jwebmp.plugins.aggridenterprise.AgGridEnterpriseColumnDef;
\`\`\``;
	mdContent_718 = `\`\`\`java
AgGridEnterpriseColumnDef()
\`\`\``;
	mdContent_719 = `\`\`\`java
AgGridEnterpriseColumnDef(String field)
\`\`\``;
	mdContent_720 = `\`\`\`java
AgGridEnterpriseColumnDef(String field, String headerName)
\`\`\``;
	mdContent_721 = `\`\`\`java
new AgGridEnterpriseColumnDef&lt;&gt;("revenue", "Revenue")
    .setAggFunc(AgGridEnterpriseColumnDef.AggFunc.SUM)
    .setAllowedAggFuncs(AgGridEnterpriseColumnDef.AggFunc.SUM, AgGridEnterpriseColumnDef.AggFunc.AVG)
    .setEnableValue(true)
    .setCellDataType(AgGridEnterpriseColumnDef.CellDataType.NUMBER);
\`\`\``;
	mdContent_722 = `\`\`\`java
new AgGridEnterpriseColumnDef&lt;&gt;("country", "Country")
    .setEnableRowGroup(true)
    .setRowGroup(true)
    .setRowGroupIndex(0);
\`\`\``;
	mdContent_723 = `\`\`\`java
new AgGridEnterpriseColumnDef&lt;&gt;("amount", "Amount")
    .setAggFunc(AgGridEnterpriseColumnDef.AggFunc.SUM)
    .setGroupTotalRow(AgGridEnterpriseColumnDef.GroupTotalRowPosition.BOTTOM)
    .setGrandTotalRow(AgGridEnterpriseColumnDef.GrandTotalRowPosition.PINNED_BOTTOM);
\`\`\``;
}
